export default __webpack_public_path__ + "static/media/virus.38acd6a1.png";